import { State } from 'modules/cm/store/cases/types';
import { ACTION_TYPES } from './types';
import { CaseDetails } from '../../../pages/CaseDetailsPage/CaseDetailsPage.types';
import { FIELDS } from 'modules/cm/fields/types';

const reducers = (state: State, action: any) => {
  return {
    [ACTION_TYPES.UPDATE_LOAN_DETAILS.toString()]: () => {
      const caseDetails = state.data as NonNullable<CaseDetails>;

      const property = { ...caseDetails.case.property };
      if (action.payload[0].propertyPurchasePrice !== undefined) {
        property[FIELDS.PROPERTY_PURCHASE_PRICE] = action.payload[0].propertyPurchasePrice;
      }
      if (action.payload[0].actualPropertyValue !== undefined) {
        property[FIELDS.ACTUAL_PROPERTY_VALUE] = action.payload[0].actualPropertyValue;
      }
      if (action.payload[0].estimatedPropertyValue !== undefined) {
        property[FIELDS.ESTIMATED_PROPERTY_VALUE] = action.payload[0].estimatedPropertyValue;
      }
      if (action.payload[0].postcode !== undefined) {
        property[FIELDS.PROPERTY_POSTCODE] = action.payload[0].postcode;
      }

      return {
        ...state,
        data: {
          ...caseDetails,
          case: {
            ...caseDetails.case,
            loanDetails: {
              ...caseDetails.case.loanDetails,
              ...action.payload[0],
            },
            property,
          },
        },
      };
    },
    [ACTION_TYPES.UPDATE_LIFE_ASSURANCE.toString()]: () => {
      const caseDetails = state.data as NonNullable<CaseDetails>;

      return {
        ...state,
        data: {
          ...caseDetails,
          case: {
            ...caseDetails.case,
            assurancePolicies: action.payload[0],
          },
        },
      };
    },
    [ACTION_TYPES.UPDATE_PROPERTY.toString()]: () => {
      const caseDetails = state.data as NonNullable<CaseDetails>;

      return {
        ...state,
        data: {
          ...caseDetails,
          case: {
            ...caseDetails.case,
            loanDetails: {
              ...caseDetails.case.loanDetails,
              [FIELDS.PROPERTY_PURCHASE_PRICE]: action.payload[0].propertyPurchasePrice,
              [FIELDS.ACTUAL_PROPERTY_VALUE]: action.payload[0].actualPropertyValue,
              [FIELDS.ESTIMATED_PROPERTY_VALUE]: action.payload[0].estimatedPropertyValue,
              [FIELDS.PROPERTY_POSTCODE]: action.payload[0].postcode,
            },
            property: action.payload[0],
          },
        },
      };
    },
    [ACTION_TYPES.UPDATE_ADMIN.toString()]: () => {
      const caseDetails = state.data as NonNullable<CaseDetails>;

      return {
        ...state,
        data: {
          ...caseDetails,
          case: {
            ...caseDetails.case,
            contact: action.payload[0],
          },
        },
      };
    },
    [ACTION_TYPES.UPDATE_REPAYMENT_STRATEGY.toString()]: () => {
      const caseDetails = state.data as NonNullable<CaseDetails>;

      return {
        ...state,
        data: {
          ...caseDetails,
          case: {
            ...caseDetails.case,
            repaymentStrategy: action.payload[0],
          },
        },
      };
    },
    [ACTION_TYPES.UPDATE_APPLICANT.toString()]: () => {
      const caseDetails = state.data as NonNullable<CaseDetails>;
      const { index, applicant } = action.payload[0];
      try {
        const applicants = caseDetails.case.applicants.map((applicantData, applicantIndex) => {
          if (applicantIndex === index) {
            if (applicantData.id !== applicant.id && applicant.id !== undefined) {
              throw new Error('Detected applicant ID change. Please refresh a case.');
            }
            return { ...applicantData, ...applicant };
          }
          return applicantData;
        });

        return {
          ...state,
          data: {
            ...caseDetails,
            case: {
              ...caseDetails.case,
              applicants,
            },
          },
        };
      } catch (e) {
        return {
          ...state,
          errorModal: e,
        };
      }
    },
    [ACTION_TYPES.UPDATE_RATIONALE.toString()]: () => {
      const caseDetails = state.data as NonNullable<CaseDetails>;
      const rationale = action.payload[0];

      return {
        ...state,
        data: {
          ...caseDetails,
          case: {
            ...caseDetails.case,
            rationale,
          },
        },
      };
    },
  };
};

export default reducers;
